import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddclientComponent } from './components/addclient/addclient.component';
import { DashbordComponent } from './components/dashbord/dashbord.component';
import { EditComponent } from './components/edit/edit.component';
import { MobilitydashbordComponent } from './components/mobilitydashbord/mobilitydashbord.component';



const routes: Routes = [

  {path:"",component: DashbordComponent},
  {path:"edit",component: EditComponent},
  {path:"addclient",component: AddclientComponent},
  {path:"mobilitydashbord/:custnum",component: MobilitydashbordComponent},
  {path:"**",redirectTo:""}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
